import React from "react";
import { ReactComponent as Logo } from "../../assets/svg/Logo.svg";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <div className="relative bg-white">
      {/* Wave SVG at the top of footer - optimized height and positioning */}
      <div className="w-full h-56 sm:h-64 md:h-72 overflow-hidden relative">
        <svg
          className="absolute w-full h-auto bottom-0"
          viewBox="0 0 1921 296"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          preserveAspectRatio="none"
          style={{ minWidth: "100%" }}
        >
          <g clipPath="url(#clip0_footer)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M1982.94 104.265C1982.94 104.265 1786.24 234.375 1519.29 255.493C1252.34 276.611 803.5 178.3 510.856 201.448C218.212 224.596 -326.665 365.123 -559.679 383.556C-792.693 401.989 -976.9 251.7 -976.9 251.7L-903.826 699.835L1631.78 631.998C1631.78 631.998 2128.21 500.955 2140.47 481.49C2152.73 462.025 1982.94 104.265 1982.94 104.265Z"
              fill="#48C9F3"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M-26.0001 233C-26.0001 233 120.2 291 306 291C491.8 291 793.322 215 997 215C1200.68 215 1587.82 287 1750 287C1912.18 287 2027 152 2027 152L2013 576L259 700C259 700 -93.9671 614.277 -104 597C-114.033 579.723 -26.0001 233 -26.0001 233Z"
              fill="#134F98"
            />
          </g>
          <defs>
            <clipPath id="clip0_footer">
              <rect width="1920" height="296" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </div>

      {/* Footer Content - improved spacing and responsiveness */}
      <footer className="bg-[#134F98] text-white pt-10 pb-8 px-4 sm:px-6 lg:px-32 relative -mt-1">
        <div className="container mx-auto max-w-full">
          {/* Footer Top Section */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12 mb-12">
            {/* Logo and About */}
            <div className="lg:col-span-1">
              <div className="flex items-center mb-5">
                <div className="w-18 h-18 rounded-lg flex items-center justify-center mr-3 shadow-lg">
                  <Logo className="w-full h-full" />
                </div>
                <div>
                  <h3 className="font-normal text-3xl leading-tight">
                    LANGUAGE
                  </h3>
                  <h3 className="font-normal text-3xl leading-tight">
                    VILLAGE
                  </h3>
                </div>
              </div>
              <p className="text-blue-100 mb-5 leading-relaxed">
                Empowering language learners worldwide with innovative teaching
                methods and personalized learning experiences.
              </p>
              <div className="flex space-x-5">
                <a
                  href="#"
                  className="text-white hover:text-[#48C9F3] transition-colors duration-300"
                >
                  <svg
                    className="w-6 h-6"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                  >
                    <path
                      fillRule="evenodd"
                      d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z"
                      clipRule="evenodd"
                    />
                  </svg>
                </a>
                <a
                  href="#"
                  className="text-white hover:text-[#48C9F3] transition-colors duration-300"
                >
                  <svg
                    className="w-6 h-6"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                  >
                    <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" />
                  </svg>
                </a>
                <a
                  href="#"
                  className="text-white hover:text-[#48C9F3] transition-colors duration-300"
                >
                  <svg
                    className="w-6 h-6"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                  >
                    <path
                      fillRule="evenodd"
                      d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z"
                      clipRule="evenodd"
                    />
                  </svg>
                </a>
                <a
                  href="#"
                  className="text-white hover:text-[#48C9F3] transition-colors duration-300"
                >
                  <svg
                    className="w-6 h-6"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                  >
                    <path
                      fillRule="evenodd"
                      d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z"
                      clipRule="evenodd"
                    />
                  </svg>
                </a>
              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="text-lg font-semibold mb-5 border-b border-white pb-2">
                Quick Links
              </h4>
              <ul className="space-y-3">
                <li>
                  <a
                    href="#"
                    className="text-blue-100 hover:text-[#48C9F3] transition-colors duration-300 flex items-center"
                  >
                    <svg
                      className="w-3.5 h-3.5 mr-2"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                        clipRule="evenodd"
                      ></path>
                    </svg>
                    Home
                  </a>
                </li>
                <li>
                  <a
                    href="#about"
                    className="text-blue-100 hover:text-[#48C9F3] transition-colors duration-300 flex items-center"
                  >
                    <svg
                      className="w-3.5 h-3.5 mr-2"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                        clipRule="evenodd"
                      ></path>
                    </svg>
                    About Us
                  </a>
                </li>
                <li>
                  <a
                    href="#courses"
                    className="text-blue-100 hover:text-[#48C9F3] transition-colors duration-300 flex items-center"
                  >
                    <svg
                      className="w-3.5 h-3.5 mr-2"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                        clipRule="evenodd"
                      ></path>
                    </svg>
                    Courses
                  </a>
                </li>
                <li>
                  <a
                    href="#methodology"
                    className="text-blue-100 hover:text-[#48C9F3] transition-colors duration-300 flex items-center"
                  >
                    <svg
                      className="w-3.5 h-3.5 mr-2"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                        clipRule="evenodd"
                      ></path>
                    </svg>
                    Methodology
                  </a>
                </li>
                <li>
                  <a
                    href="#testimonials"
                    className="text-blue-100 hover:text-[#48C9F3] transition-colors duration-300 flex items-center"
                  >
                    <svg
                      className="w-3.5 h-3.5 mr-2"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                        clipRule="evenodd"
                      ></path>
                    </svg>
                    Testimonials
                  </a>
                </li>
                <li>
                  <a
                    href="#contact-section"
                    className="text-blue-100 hover:text-[#48C9F3] transition-colors duration-300 flex items-center"
                  >
                    <svg
                      className="w-3.5 h-3.5 mr-2"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                        clipRule="evenodd"
                      ></path>
                    </svg>
                    Contact
                  </a>
                </li>
              </ul>
            </div>

            {/* Contact Info */}
            <div>
              <h4 className="text-lg font-semibold mb-5 border-b border-white pb-2">
                Contact Us
              </h4>
              <div className="space-y-4">
                <div className="flex items-start">
                  <svg
                    className="w-5 h-5 mt-1 mr-3 text-[#48C9F3]"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                    ></path>
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                    ></path>
                  </svg>
                  <p className="text-blue-100">
                    123 Language Street, San Francisco, CA 94103
                  </p>
                </div>
                <div className="flex items-start">
                  <svg
                    className="w-5 h-5 mt-1 mr-3 text-[#48C9F3]"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                    ></path>
                  </svg>
                  <p className="text-blue-100">+1 (555) 123-4567</p>
                </div>
                <div className="flex items-start">
                  <svg
                    className="w-5 h-5 mt-1 mr-3 text-[#48C9F3]"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                    ></path>
                  </svg>
                  <p className="text-blue-100">info@languagevillage.com</p>
                </div>
                <div className="flex items-start">
                  <svg
                    className="w-5 h-5 mt-1 mr-3 text-[#48C9F3]"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                    ></path>
                  </svg>
                  <p className="text-blue-100">Monday-Friday: 9am-6pm EST</p>
                </div>
              </div>
            </div>
          </div>

          {/* Newsletter - improved styling */}
          <div className="border-t border-white pt-10 pb-10">
            <div className="max-w-xl mx-auto text-center">
              <h4 className="text-xl font-semibold mb-4">
                Subscribe to Our Newsletter
              </h4>
              <p className="text-blue-100 mb-6 max-w-md mx-auto">
                Stay updated with our latest courses, teaching methods, and
                language learning tips.
              </p>
              <form className="flex flex-col sm:flex-row gap-3">
                <input
                  type="email"
                  placeholder="Your email address"
                  className="flex-grow px-4 py-3 rounded-md focus:outline-none focus:ring-2 focus:ring-[#48C9F3] text-gray-800"
                  required
                />
                <button
                  type="submit"
                  className="bg-[#48C9F3] hover:bg-[#3ab8e2] text-white font-medium py-3 px-6 rounded-md transition-colors duration-300 shadow-md"
                >
                  Subscribe
                </button>
              </form>
            </div>
          </div>

          {/* Copyright - improved styling */}
          <div className="border-t border-white pt-8 text-center">
            <p className="text-blue-200 text-sm">
              © {currentYear} Language Village. All rights reserved.
            </p>
            <div className="mt-4 flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm">
              <a
                href="#"
                className="text-blue-200 hover:text-[#48C9F3] transition-colors duration-300"
              >
                Privacy Policy
              </a>
              <a
                href="#"
                className="text-blue-200 hover:text-[#48C9F3] transition-colors duration-300"
              >
                Terms of Service
              </a>
              <a
                href="#"
                className="text-blue-200 hover:text-[#48C9F3] transition-colors duration-300"
              >
                Cookie Policy
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
